/* Public editorial surfaces (blog index + help center).
 *
 * Lives in the bundle rather than an inline <script> because these pages render
 * through the landing layout, whose CSP has no 'unsafe-inline' — the previous
 * inline block in Views/Blog/Index.cshtml would simply not run there.
 */

function initBlogTagPanel() {
  const toggle = document.getElementById("blog-tags-toggle");
  const panel = document.getElementById("blog-tags-panel");
  if (!toggle || !panel) return;

  const search = document.getElementById("blog-tags-search");

  toggle.addEventListener("click", () => {
    const expanded = toggle.getAttribute("aria-expanded") === "true";
    toggle.setAttribute("aria-expanded", String(!expanded));
    panel.classList.toggle("open");
    if (!expanded && search) search.focus();
  });

  if (!search) return;

  search.addEventListener("input", () => {
    const query = search.value.trim().toLowerCase();
    panel.querySelectorAll(".blog-tag-pill").forEach((pill) => {
      const tag = pill.getAttribute("data-tag") || "";
      pill.classList.toggle("blog-tag-hidden", query !== "" && tag.indexOf(query) === -1);
    });
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initBlogTagPanel);
} else {
  initBlogTagPanel();
}
